/**
 * Messages API
 */

import { apiClient } from './client';
import type {
  GetMessagesParams,
  GetMessagesResponse,
  SendMessageRequest,
  SendMessageResponse,
} from './types';

/**
 * Get messages for a conversation with pagination
 */
export async function getMessages(
  params: GetMessagesParams
): Promise<GetMessagesResponse> {
  return apiClient<GetMessagesResponse>('get-messages', {
    params: {
      conversation_id: params.conversationId,
      limit: params.limit,
      cursor: params.cursor,
      since: params.since,
    },
  });
}

/**
 * Send a message to a conversation
 */
export async function sendMessage(
  request: SendMessageRequest
): Promise<SendMessageResponse> {
  return apiClient<SendMessageResponse>('send-message', {
    method: 'POST',
    body: request,
  });
}
